import { collection, getDocs, getFirestore } from 'firebase/firestore';
import { getApp } from 'firebase/app';
import { DBCollection } from '@/lib/utils/constants-shared';

/**
 * Fetch all culture by book data from Firestore
 */
export async function fetchCultureByBookFromDB(): Promise<CultureByBook[]> {
  const db = getFirestore(getApp());
  const cultureByBookCollection = collection(db, DBCollection.cultureByBook);
  const snapshot = await getDocs(cultureByBookCollection);

  return snapshot.docs.map(doc => {
    const data = doc.data() as FirebaseCultureByBook<any>;
    return {
      ...data,
      dateCreated: data.dateCreated.toDate(),
      dateUpdated: data.dateUpdated.toDate()
    } as CultureByBook;
  });
}

